import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { HasRoleGuard } from './core/auth/guards/has-role.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
        ]
    },

    // Admin routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)},
        ]
    },

    {
        path:'',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children:[
            {path:'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.module').then(m=>m.DashboardModule)},
            {path:'profile', loadChildren: () => import('app/modules/admin/profile/profile.module').then(m=>m.ProfileModule)},
            {path:'users', canActivate: [HasRoleGuard], data: {roles: ['ROLE_Super Admin', 'ROLE_Admin','ROLE_Relationship Manager']}, loadChildren: () => import('app/modules/user/user.module').then(m=>m.UserModule)},
            {path:'partners', canActivate: [HasRoleGuard], data: {roles: ['ROLE_Super Admin', 'ROLE_Admin','ROLE_Partner Admin','ROLE_Operations','ROLE_Relationship Manager']}, loadChildren: () => import('app/modules/partner/partner.module').then(m=>m.PartnerModule)},
            {path:'loans', loadChildren: () => import('app/modules/loan/loan.module').then(m=>m.LoanModule)},
            {path:'leads', loadChildren: () => import('app/modules/lead/leads.module').then(m=>m.LeadsModule)},
            {path:'legacy-loans', canActivate: [HasRoleGuard], data: {roles: ['ROLE_Super Admin', 'ROLE_Admin']}, loadChildren: () => import('app/modules/legacy-loans/legacy-loans.module').then(m=>m.LegacyLoansModule)},
            {path:'uscisFee', canActivate: [HasRoleGuard], data: {roles: ['ROLE_Super Admin', 'ROLE_Admin']}, loadChildren: () => import('app/modules/governmentFee/governmentFee.module').then(m=>m.GovernmentFeeModule)},
            {
                path:'report',
                canActivate: [HasRoleGuard],
                data: {roles: ['ROLE_Super Admin', 'ROLE_Admin', 'ROLE_Relationship Manager', 'ROLE_Partner Admin', 'ROLE_Billing']},
                loadChildren: () => import('app/modules/report/report.module').then(m=>m.ReportModule)
            }
        ]
    }
];
